module.exports = __webpack_public_path__ + "img/login.8736157.jpg";